import {Component, ElementRef, HostListener, Input} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'user-control-nav',
  templateUrl: './user-control-nav.component.html',
  styleUrls: ['./user-control-nav.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserControlNavComponent {

  @Input() user: User;

  open$ = new BehaviorSubject(false);

  constructor(private el: ElementRef) {
  }

  @HostListener('window:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const elem = this.el.nativeElement as HTMLElement;
    if (!elem || !elem.contains || !target) return;
    if (this.open$.getValue() && !elem.contains(target)) this.toggleControlNav();
  }

  toggleControlNav() {
    this.open$.next(!this.open$.getValue());
  }

}

